import React from 'react';

// custom components //
import { EditTimelineBookingFormV2 } from "_molecules";
import { useSelector } from 'react-redux';
import { selectJob } from '_redux/slices/utils/menu-context';
import EditTask from './edit-task-form';
import EditAltPickupDetails from '_components/molecules/assistance-bookings/edit-alt-pickup-details';

const EditTimelineBooking = (props) => {
    const job = useSelector(selectJob);

    // Get the actual booking doc (handle arrival docs with originalBookingDoc)
    const booking = job?.originalBookingDoc ? job?.originalBookingDoc : job;

    // Check if this is an ALT pickup task
    const isALTPickup = booking?.isALTPickUp === true;

    return (
        <div style={{ zIndex: "initial" }}>
            {/* ALT Pickup tasks - use dedicated component */}
            {isALTPickup ? (
                <EditAltPickupDetails
                    job={booking}
                    onSuccess={props.onClose}
                />
            ) : (
                /* Regular bookings and tasks */
                job?.assignedTime ? (
                    <EditTask />
                ) : (
                    <EditTimelineBookingFormV2
                        close={props.onClose}
                        locationSelectTitle={props?.locationSelectTitle ?? ""}
                        btnTitle={props?.btnTitle ?? ""}
                        placeholder={props?.placeholder ?? ""}
                        forCheckIn={props?.forCheckIn ?? false}
                        handleGetBookings={props?.handleGetBookings}
                    />
                )
            )}
        </div>
    )
}

export default EditTimelineBooking